export const screens = {
  mobile: '576px',
  tablet: '640px',
  laptop: '1024px',
  desktop: '1280px',
};
